import React, { useState } from "react"
import { Check, Clipboard } from "lucide-react"
import { CodeText, Container, CopyButton } from "./styles"

interface PixCodeDisplayProps {
  code: string
}

export function Copyable({ code }: PixCodeDisplayProps) {
  const [copied, setCopied] = useState(false)

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(code)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (err) {
      console.error("Failed to copy:", err)
    }
  }

  return (
    <Container onClick={handleCopy}>
      <CodeText style={{ maxWidth: "232px" }} title={code}>{code}</CodeText>
      <CopyButton aria-label="Copy code">
        {copied ? <Check size={18} color="green" /> : <Clipboard size={18} />}
      </CopyButton>
    </Container>
  )
}
